import { render, staticRenderFns } from "./PageWrapperWithSidebar.vue?vue&type=template&id=2b43a5f9&"
import script from "./PageWrapperWithSidebar.vue?vue&type=script&lang=js&"
export * from "./PageWrapperWithSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PageWrapperWithSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports